import http from '../../../api/axios';
import { apiUrl } from '../../../api/apiUrl';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Loader } from '../../../components/loader/Loader';
import { useTranslation } from '../../../context/translationContext';
import { paths } from '../../RouterContainer';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';
import { INVOICE_TABS } from '../InvoicePage/InvoiceSidePanel';
import { SmartAttachmentForm } from '../../../forms/SmartAttachment/SmartAttachmentForm';
import { SmartAttachmentInputs } from '../../../types/SmartAttachment';
import { useLoading } from '../../../context/loadingContext';

/**
 * Page component for editing existing smart attachment
 */
export const SmartAttachmentUpdatePage = () => {
  const { documentId, id } = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState<SmartAttachmentInputs | null>(null);
  const navigate = useNavigate();
  const { setBreadcrumbs } = useBreadcrumbs();
  const { startLoading, stopLoading } = useLoading();
  useEffect(() => {
    setBreadcrumbs([
      { path: `${paths.INVOICES}`, name: 'navigation.documents' },
      { path: `${paths.INVOICE}/${documentId}`, name: 'navigation.document-detail' },
      {
        path: `${paths.INVOICE}/${documentId}/${paths.SMART_ATTACHMENTS}/edit/${id}`,
        name: 'navigation.smart-attachment-edit',
      },
    ]);
  }, []);

  /**
   * Back button action
   */
  const handleOnBack = () =>
    navigate(`/${paths.INVOICE}/${documentId}`, {
      state: { tab: INVOICE_TABS.SMART_ATTACHMENTS },
    });

  /**
   * Loads smart attachment
   */
  const fetchData = async () => {
    const response = await http.apiGet({
      url: `${apiUrl.SMART_ATTACHMENT_ITEM}?id=${id}`,
    });
    setData(response?.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  /**
   * Handles edit action for new company bank account form submit.
   * @param values form data
   */
  const handleSubmit = async (values: SmartAttachmentInputs) => {
    try {
      startLoading();
      const response = await http.apiPut({ url: apiUrl.SMART_ATTACHMENT_UPDATE, data: values });
      if (response?.status === 200) {
        stopLoading();
        toast.success('Success!');
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  if (!data) return <Loader />;
  return (
    <>
      <div>
        <h1 className="text-3xl font-bold">{t('page.smart-attachment.headline-edit')}</h1>
        <SmartAttachmentForm onSubmit={handleSubmit} onBack={handleOnBack} initialValues={data} />
      </div>
    </>
  );
};
